export default __webpack_public_path__ + "static/8-442f38415e86ef95b8762ce80d467645.webp";